/**
 * Check for deletion confirmation.
 * @param test - The test string.
 * @param confirmation - The confirmation string.
 * @param prefix - The prefix to use.
 */
export const deletionConfirmation = (test: string, confirmation: string, prefix = "Delete") => {
  return test === `${prefix} ${confirmation.trim()}`
}
